import { ComponentProps } from 'react'

import { StatusLabel } from '@factorialco/deprecated-design-system'
import { isWithinInterval, parseISO, subMonths } from 'date-fns'
import { AuthenticationDomainStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Props = {
  status: AuthenticationDomainStatusEnum
  lastVerifiedAt: string | null
}

export const DomainStatusLabel = ({ status, lastVerifiedAt }: Props) => {
  let type: ComponentProps<typeof StatusLabel>['type']
  let label: string

  // Helper function to check if the date is within the last month
  const isLastMonth = (dateStr: string | null) => {
    if (!dateStr) return false
    const date = parseISO(dateStr)
    return isWithinInterval(date, { start: subMonths(new Date(), 1), end: new Date() })
  }

  if (status === 'verified') {
    type = 'info'
    label = i18n.t('security_settings.domain.status.verified')
  } else if (status === 'missing_token' && lastVerifiedAt !== null) {
    if (isLastMonth(lastVerifiedAt)) {
      type = 'warning'
      label = i18n.t('security_settings.domain.status.missing_token')
    } else {
      type = 'critical'
      label = i18n.t('security_settings.domain.status.missing_token')
    }
  } else {
    type = 'neutral'
    label = i18n.t('security_settings.domain.status.unverified')
  }

  return <StatusLabel type={type}>{label}</StatusLabel>
}
